var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGenericIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "90px",
    height: "90px",
    viewBox: "0 0 90 90",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "generic-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "generic-icon",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70,10 C75.5228475,10 80,14.4771525 80,20 L80,70 C80,75.5228475 75.5228475,80 70,80 L20,80 C14.4771525,80 10,75.5228475 10,70 L10,20 C10,14.4771525 14.4771525,10 20,10 L70,10 Z M27,54.6363636 L27,65 L37.3636364,65 C37.3636364,59.2654545 32.7345455,54.6363636 27,54.6363636 Z M27,27 L27,33.9090909 C44.1690909,33.9090909 58.0909091,47.8309091 58.0909091,65 L65,65 C65,43.9963636 47.9690909,27 27,27 Z M27,40.8181818 L27,47.7272727 C36.5345455,47.7272727 44.2727273,55.4654545 44.2727273,65 L51.1818182,65 C51.1818182,51.6309091 40.3690909,40.8181818 27,40.8181818 Z",
    id: "Combined-Shape",
    fill: "#CBCBCB"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenericIcon);
export default __webpack_public_path__ + "static/media/generic-icon.b9d4f73d431337c41d25db0cde32c43b.svg";
export { ForwardRef as ReactComponent };